// API Configuration
const NOUH_MASJID_ID = 576;
const configuredMasjidId = Number(process.env.REACT_APP_MASJID_ID);

export const DEFAULT_MASJID_ID =
  Number.isInteger(configuredMasjidId) && configuredMasjidId > 0
    ? configuredMasjidId
    : NOUH_MASJID_ID;

export const API_CONFIG = {
  // Base URLs
  CONNECT_UMMAH_API: process.env.REACT_APP_API_BASE_URL || "https://api.connectummah.com/api",
  ADMIN_API: process.env.REACT_APP_ADMIN_API_BASE_URL || "https://adminapi.connectummah.com/api",
  LOCAL_API: process.env.REACT_APP_LOCAL_API_BASE || "http://localhost:5000/api",
  
  // External APIs
  ALADHAN_API: "https://api.aladhan.com/v1",
  TIME_API: "https://www.timeapi.io/api/Time/current/coordinate",
  
  // CDN
  IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL || "https://cdn.connectummah.com/myuploadfiles/",
  
  // Default Configuration
  DEFAULT_PUBLIC_ID: process.env.REACT_APP_PUBLIC_ID || "VZ4D08",
  DEFAULT_MASJID_ID,
  
  // Prayer calculation method (for AlAdhan API)
  PRAYER_CALCULATION_METHOD: 2, // Islamic Society of North America (ISNA)
  
  // Timeouts
  API_TIMEOUT: 10000, // 10 seconds
  
  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
};

// Helper function to get auth headers
export const getAuthHeaders = (token = null) => ({
  "Content-Type": "application/json",
  "Accept": "application/json",
  ...(token && { "Authorization": `Bearer ${token}` })
});

// Helper function to build API URLs
export const buildApiUrl = (baseUrl, endpoint, params = {}) => {
  const url = new URL(endpoint, baseUrl);
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      url.searchParams.append(key, params[key]);
    }
  });
  return url.toString();
};

export default API_CONFIG;
